'use strict';
var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');
var offcanvas = require('honda_cars_ecux/ecux/vendors/bootstrap-5.3/offcanvas');
const { configuratorCtas } = require('../configuratorCtas');

const BREAKPOINTS = {
    sm: 441,
    md: 1024,
    lg: 1440
}

/**
 *
 * Module handling the summary stage of the vehicle configurator UX.
 * Exposes an object with lifecycle methods used by the configurator page
 * to update the cart summary, drive-away price, finance details, cross
 * border delivery info and small UI behaviours.
 *
 */
const configuratorStageSummary = {
    afterCartSummaryUpdate: function (data) {
        var updateDriveAwayPriceComponents = this.updateDriveAwayPriceComponents.bind(this);
        var updateCrossBorderDeliveryData = this.updateCrossBorderDeliveryData.bind(this);
        var updateSummaryReccomendations = this.updateSummaryReccomendations.bind(this);
        var updateSummaryRefundPrice = this.updateSummaryRefundPrice.bind(this);
        var updateSummaryBuildYear = this.updateSummaryBuildYear.bind(this);
        var updateTestDriveCTA = this.updateTestDriveCTA.bind(this);

        updateDriveAwayPriceComponents(data.totals.finalDriveAwayPrice);
        updateSummaryRefundPrice(data.totals.grandTotal);
        updateCrossBorderDeliveryData(data);
        updateSummaryReccomendations();
        updateSummaryBuildYear();
        updateTestDriveCTA();
    },
    updateSummaryBuildYear: function () {
        // TODO: (refactor): Need to Rendering the build year on the server-side
        var $totalsFieldValueBuildYear = $('#totals-field-value-variation-year');
        var $productBuildYearFull = $('.internal-Vehicle-number').find('input[name="productionDate"]').attr('value');
        if ($productBuildYearFull) {
            var $BuildYearDateObject = new Date($productBuildYearFull);
            var $buildYear = $BuildYearDateObject.getFullYear();
            $totalsFieldValueBuildYear.html($buildYear + ' build year');
        }
    },
    updateFinanceComponent: function(financeData) {
        if ($('.finance-main').hasClass('d-none')) {
            $('#navbar-header-finance-summary').addClass('d-none');
        } else {
            $('#navbar-header-finance-summary').removeClass('d-none');
        }
        if (financeData && financeData.weeklyRepayment && financeData.comparisonRate && financeData.rate) {
            $('.finance-payment').html(financeData.weeklyRepayment);
            $('.finance-rate').html(financeData.comparisonRate);
            $('.interest-rate').html(financeData.rate);
            $('.navbar-header-finance-summary').removeClass('d-none').addClass('d-flex');
            $('.configurator-footer-drive-away-price-m-container').addClass('text-left');
        } else {
            $('.navbar-header-finance-summary').addClass('d-none').removeClass('d-flex');
        }
    },
    validateVinTimer: function (pid) {
        var vinTimerID = `timer-vin-timer-${pid}`;
        if (sessionStorage.getItem(vinTimerID)) {
            console.info('Returning customer Order timer reset', vinTimerID);
            sessionStorage.removeItem(vinTimerID);
        }
    },
    updateCartSummary: function () {
        var afterCartSummaryUpdate = this.afterCartSummaryUpdate.bind(this);
        var syncUpsellCampaignUX = this.syncUpsellCampaignUX.bind(this);
        var updateSummaryHero = this.updateSummaryHero.bind(this);
        var validateVinTimer = this.validateVinTimer.bind(this);
        var $configuratorSummaryTotals = $('#configurator-summary-totals');
        $.spinner().start();
        $.ajax({
            url: $configuratorSummaryTotals.data('action'),
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $configuratorSummaryTotals.html(data.productDetailsCartSummary);
                if (typeof window.configurator.syncOnlineOrderingCTAs === 'function') {
                    window.configurator.syncOnlineOrderingCTAs(
                        $('body').data('isOnlineOrderingEnabled') === true
                    );
                }
                updateSummaryHero(data.basketModel);
                afterCartSummaryUpdate(data.basketModel);
                syncUpsellCampaignUX();
                setTimeout(() => {
                    frontendUtils.deleteUrlParams('showSummary');
                    localStorage.removeItem('syncTabRefresh');
                }, 1000);
                validateVinTimer(data.basketModel.vehicleProduct.id);
                $.spinner().stop();
            }
        });
    },
    updateSummaryHero: function (data) {
        // TODO: (optimize): Need to Create a new template and render in the backend template.
        var updateFinanceComponent = this.updateFinanceComponent.bind(this);

        var $summaryHeroDriveAway = $('#summary-hero-drive-away');
        var $summaryHeroHeroTitle = $('#summary-hero-title');
        var $summaryFieldDealerName = $('#configurator-summary-dealer-name');

        var vehicleVariationName = data.vehicleProduct.productName;
        var vehicleGradeName = data.vehicleProduct.customProps.GradeDesc;
        if (vehicleVariationName.toLowerCase().includes(vehicleGradeName.toLowerCase())) {
            $summaryHeroHeroTitle.html(vehicleVariationName);
        } else {
            $summaryHeroHeroTitle.html(`${vehicleVariationName} ${vehicleGradeName}`);
        }

        $summaryHeroDriveAway.html(data.totals.finalDriveAwayPrice + '*');

        if (frontendUtils.getCookie('userloc')) {
            var userLocation = JSON.parse(frontendUtils.getCookie('userloc'));
            var dealerName = userLocation.dealer.dealerName;
            $summaryFieldDealerName.html(dealerName);
        }

        updateFinanceComponent(data.finance);
    },
    updateCrossBorderDeliveryData: function (data) {
        var urlParams = new URLSearchParams(window.location.search);
        // Do not show cross-border in summary for showroom stock configurations
        if (urlParams.get('showroomStock') === 'true') return;
        var crossBorderDelivery = urlParams.get('crossBorderDelivery') || '';
        if (!crossBorderDelivery && data.totals.CrossBorderDelivery && data.totals.CrossBorderCharge !== '-') {
            var crossBorderAvailabilityMessage = $('#cross-border-availability-msg').val();
            var parsedAvailabilityMonths = crossBorderAvailabilityMessage.replace(/available\s*/i, '').trim();
            $('#summary-cross-border-details').removeClass('d-none');
            $('.summary-get-cross-border-text').text('Get it in ' + parsedAvailabilityMonths + ' for + $' + data.totals.CrossBorderCharge);
        }

        if (crossBorderDelivery) {
            $('#summary-cross-border-price-summary').removeClass('d-none');
            $('#summary-cross-border-price').text('$' + data.totals.CrossBorderCharge);
        }
    },
    updateSummaryReccomendations: function () {
        // TODO: (cleanup): Move recommendation-specific logic into the
        // dedicated recommendations file and also move form htmx to simple ajex call.
        var $configuratorSummaryAccessoriesCSell = $('#product-summary-recommendations-accessories-cross-sell');
        var $configuratorSummaryAccessories = $('#configurator-summary-accessories');
        var $configuratorSummaryAccessoriesPak = $('#configurator-summary-accessories-pack');
        $configuratorSummaryAccessoriesCSell.removeAttr('data-hx-revealed');
        $configuratorSummaryAccessories.removeAttr('data-hx-revealed');
        $configuratorSummaryAccessoriesPak.removeAttr('data-hx-revealed');
    },
    updateDriveAwayPriceComponents: function (finalDriveAwayPrice) {
        var $configuratorFooterDriveAwayPriceMobile = $('#configurator-footer-drive-away-price-m');
        var $orderNowCtas = configuratorCtas.$orderNow();
        var initialDriveAwayPrice = $('#configurator-header-drive-away-price').html();
        var $headerDriveAwayPrice = $('#configurator-header-drive-away-price');
        var $totalsFieldValueBasePrice = $('#totals-field-value-base-price');
        var $modifyOrderPrice = $('#totals-field-value-modify-order-price');
        var $summaryHeroDriveAway = $('#summary-hero-drive-away');
        var driveAwayPrice = finalDriveAwayPrice;

        if (!driveAwayPrice || driveAwayPrice == '-') {
            $headerDriveAwayPrice.addClass('d-none');
            $configuratorFooterDriveAwayPriceMobile.addClass('d-none');
            if (frontendUtils.getCookie('dapModalShown')) {
                $('.gst-copy').addClass('d-none');
                $('.header-dap').addClass('d-none');
                $('#configurator-dap-not-available').removeClass('d-none').addClass('d-flex');
                $('#configurator-dap-not-available-header').removeClass('d-none');
            } else {
                frontendUtils.setCookie(
                    'dapModalShown',
                    'true'
                );
                if (window.innerWidth < BREAKPOINTS.sm) {
                    let driveAwayPriceErrorOffCanvas = new offcanvas('#offcanvasDriveAwayPriceErrorBottom', { backdrop: 'static', keyboard: false });
                    driveAwayPriceErrorOffCanvas.show();
                } else {
                    $('#drive-away-price-error-modal').modal('show');
                }
                $('<div class="skeleton skeleton-md px-5 mb-2"></div>').insertAfter($headerDriveAwayPrice);
                $('<div class="skeleton skeleton-md px-5 mb-2"></div>').insertAfter($configuratorFooterDriveAwayPriceMobile);
            }
            driveAwayPrice = "Price couldn't be retrieved";
            $summaryHeroDriveAway.addClass('text-primary').addClass('d-none');
            $orderNowCtas.addClass('disabled');
            $configuratorFooterDriveAwayPriceMobile.addClass('text-primary');
            $headerDriveAwayPrice.addClass('text-primary');
        } else {
            $('#configurator-dap-not-available').removeClass('d-flex').addClass('d-none');
            $('#configurator-dap-not-available-header').addClass('d-none');
            $('.gst-copy').removeClass('d-none');
            $headerDriveAwayPrice.removeClass('d-none');
            $('.header-dap').removeClass('d-none');
            $headerDriveAwayPrice.removeClass('text-primary');
            $summaryHeroDriveAway.removeClass('color-primary').removeClass('d-none');
            if (configuratorCtas.isProductOrderable()) {
                $orderNowCtas.removeClass('disabled');
            }

            configuratorCtas.reapplyOrderNowDisabled();
            $configuratorFooterDriveAwayPriceMobile.removeClass('text-primary');
        }

        if ($modifyOrderPrice.html().trim() !== '') {
            $modifyOrderPrice.removeClass('d-none');
            $totalsFieldValueBasePrice.addClass('d-none');
        }

        $headerDriveAwayPrice.html(driveAwayPrice + '*');
        $configuratorFooterDriveAwayPriceMobile.html(driveAwayPrice + '*');

        $('#configuratorConfigure-tab').on('click', function () {
            $headerDriveAwayPrice.removeClass('text-primary');
            $headerDriveAwayPrice.html(initialDriveAwayPrice);
        });

        $('#customse-prev').on('click', function () {
            $configuratorFooterDriveAwayPriceMobile.removeClass('text-primary');
            $configuratorFooterDriveAwayPriceMobile.html(initialDriveAwayPrice);
        });
    },
    updateSummaryRefundPrice: function (refundPrice) {
        var $refundMsgDeposit = $('.summary-refund-msg-deposit');
        $refundMsgDeposit.html(frontendUtils.formatCurrency(refundPrice));
    },
    updateTestDriveCTA: function () {
        //TODO: (verify/remove): Need to validate where it is being used and why, also
        // if still needed move logic to backend teamplate.
        // data-online-ordering is synced from Product-Variation (element always in DOM).
        if ($('#configuratorOrder-tab').attr('data-online-ordering') !== 'true') {
            $('.configurator-footer-actions-test-drive').each(function () {
                var $btn = $(this);
                if ($btn.hasClass('btn-secondary')) {
                    $btn.removeClass('btn-secondary').addClass('btn-primary');
                }
                $btn.find('span.color--nutral-90').each(function () {
                    $(this).removeClass('color--nutral-90').addClass('white');
                });
            });
        }

        // Summary landing (no tab click): next goes to Order, hidden when Order is unavailable.
        if ($('#configuratorSummary-tab').hasClass('active')) {
            $('#summary-next').toggleClass('d-none', $('#configuratorOrder-tab').hasClass('d-none'));
        }
    },
    setupPageListeners: function () {
        var updateCartSummary = this.updateCartSummary.bind(this);
        var syncUpsellCampaignUX = this.syncUpsellCampaignUX.bind(this);

        // $('#summary-action-modify-configuration').on('click', function () {
        //     $('#configuratorConfigure-tab').trigger('click');
        // });

        $('#configuratorSummary-tab-proxy').on('click', function () {
            $('#configurator-footer-actions-summary').trigger('click');
        });

        $('body').on('click', '#summary-remove-cross-border-price', function (e) {
            e.preventDefault();
            frontendUtils.deleteUrlParams('crossBorderDelivery,crossBorderCharge,showSummary');
            $('.cross-border-alert-message').addClass('d-none');
            location.reload();
        });

        $(document).on('click', '#drive-away-price-off-canvas-refresh-btn, #drive-away-price-refresh-btn', function () {
            $('body').spinner().start();
            window.location.reload();
        });

        $('body').on('product:afterAddToCart', function () {
            updateCartSummary();
        });

        $('body').on('configurator:stageUpdate:configure', function () {
            var $footerActionsCheckout = $('#configurator-footer-actions-checkout');
            var $footerActionsSummary = $('#configurator-footer-actions-summary');
            var $configuratorLocationConfirm = $('#configurator-location-confirm');
            $footerActionsCheckout.addClass('d-none');
            $footerActionsSummary.removeClass('d-none');
            $configuratorLocationConfirm.removeClass('configurator-stage-summary');
            $('body').removeClass('configurator-stage-summary');
        });

        $('body').on('configurator:stageUpdate:summary', function () {
            var $configuratorLocationConfirm = $('#configurator-location-confirm');
            $configuratorLocationConfirm.addClass('configurator-stage-summary');
            syncUpsellCampaignUX()
        });

        $(document).on('click', '.refund-message-card .tooltip-activator', function () {
            $('.configurator-summary__inclusions__field-set').toggleClass('d-none');
        });

        document.body.addEventListener('htmx:afterSettle', function (event) {
            window.lazyLoadInstance.update();
        });

        /* Events that shoud load on page loat */
        $('body').on('configurator:imagesCarousel:no-tabs:init', function() {
            var $SummaryVariationImages = $('#summary-variation-images');
            if($SummaryVariationImages.find('.carousel-item').length > 1) {
                $SummaryVariationImages.find('.carousel-control-next').trigger('click');
            }
        });
    },
    initSummaryEvents: function () {
        /* events that be triggred based on customer interactions example cta clicks.*/
    },
    syncUpsellCampaignUX: function () {
        var $upsellAccessories = $('#product-recommendations-up-sell-slot .recommendation-tiles');
        var $upsellAccessoriesConfig = $('#product-recommendations-up-sell-slot .recommendation-lazy');
        var slidesCount = parseInt($upsellAccessories.data('slides-count')) || 1;
        slidesCount = slidesCount > 3 ? 3 : slidesCount;

        if (slidesCount <= 1) {
            if ($upsellAccessories.hasClass('slick-initialized')) {
                $upsellAccessories.slick('unslick');
                $upsellAccessoriesConfig.addClass('d-flex justify-content-center');
            }
            return;
        }

        $upsellAccessoriesConfig.removeClass('d-flex justify-content-center');

        $upsellAccessories.data('slick', {
            "slidesToShow": slidesCount,
            "slidesToScroll": slidesCount,
            "dots": true,
            "arrows": false
        });
        var slideConfig = $upsellAccessories.data('slick');
        slideConfig = {
            ...{
                arrows: false,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 1023,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            arrows: false,
                        }
                    }
                ]
            }, ...slideConfig
        };

        if ($upsellAccessories.hasClass('slick-initialized')) {
            $upsellAccessories.slick('unslick');
        }

        $upsellAccessories.slick(slideConfig);
    },
    init: function () {
        this.initSummaryEvents();
        this.setupPageListeners();
    },
}

module.exports = configuratorStageSummary;
